/**
 * 콘텐츠 자동화 시스템 - 토픽 DB
 * 교사 타겟 콘텐츠 주제 200개+
 * 
 * 구조:
 * - category: 대분류
 * - topic: 콘텐츠 주제
 * - keywords: SEO 키워드
 * - season: 시즌 (all, spring, summer, fall, winter, semester-start, semester-end)
 * - whatquizLink: 왓퀴즈 연결 (자연스러운 CTA)
 * - priority: 우선순위 (1-5, 5가 가장 높음)
 */

export const contentTopics = [
  // ==========================================
  // 🎓 생기부 관련 (30개)
  // ==========================================
  {
    id: 'saenggibu-001',
    category: '생기부',
    topic: '2026 생기부 기재요령 변경사항 총정리',
    keywords: ['2026 기재요령', '생기부 변경사항', '생활기록부 작성'],
    season: 'semester-start',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'saenggibu-002',
    category: '생기부',
    topic: '세부능력특기사항 잘 쓰는 법 - 구체적 사례 포함',
    keywords: ['세특 쓰는 법', '세부능력특기사항 예시', '생기부 잘 쓰는 법'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'saenggibu-003',
    category: '생기부',
    topic: '행동발달상황 작성 요령 - 금지어와 권장어',
    keywords: ['행발 쓰는 법', '행동발달상황 예시', '생기부 금지어'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'saenggibu-004',
    category: '생기부',
    topic: '30명 학급 생기부, 3일 만에 끝내는 현실적인 방법',
    keywords: ['생기부 빨리 쓰는 법', '생기부 효율', '학기말 생기부'],
    season: 'semester-end',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'saenggibu-005',
    category: '생기부',
    topic: '교과별 세특 작성 팁 - 국어, 영어, 수학',
    keywords: ['국어 세특', '영어 세특', '수학 세특 예시'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'saenggibu-006',
    category: '생기부',
    topic: '사회/역사 교과 세특 작성 완벽 가이드',
    keywords: ['사회 세특', '역사 세특', '사회과 생기부'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'saenggibu-007',
    category: '생기부',
    topic: '과학 교과 세특 - 탐구 활동 기록 요령',
    keywords: ['과학 세특', '탐구활동 기록', '실험 생기부'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'saenggibu-008',
    category: '생기부',
    topic: '예체능 교과 세특 작성법 (음악, 미술, 체육)',
    keywords: ['음악 세특', '미술 세특', '체육 세특'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'saenggibu-009',
    category: '생기부',
    topic: '생기부 글자수 제한 - 교과별 최대 글자수 정리',
    keywords: ['생기부 글자수', '세특 글자수', '행발 글자수'],
    season: 'all',
    whatquizLink: '/saenggibu-inspector',
    priority: 4
  },
  {
    id: 'saenggibu-010',
    category: '생기부',
    topic: '생기부 자주 하는 실수 TOP 10과 해결법',
    keywords: ['생기부 실수', '생기부 오류', '생기부 주의사항'],
    season: 'all',
    whatquizLink: '/saenggibu-inspector',
    priority: 4
  },
  {
    id: 'saenggibu-011',
    category: '생기부',
    topic: '학기말 생기부 마감 체크리스트',
    keywords: ['생기부 마감', '학기말 체크리스트', '생기부 검토'],
    season: 'semester-end',
    whatquizLink: '/saenggibu-inspector',
    priority: 5
  },
  {
    id: 'saenggibu-012',
    category: '생기부',
    topic: '생기부에서 피해야 할 표현 50가지',
    keywords: ['생기부 금지 표현', '생기부 피해야 할 표현', '생기부 주의'],
    season: 'all',
    whatquizLink: '/saenggibu-inspector',
    priority: 4
  },
  {
    id: 'saenggibu-013',
    category: '생기부',
    topic: '동아리 활동 기록 - 의미 있게 쓰는 방법',
    keywords: ['동아리 생기부', '창체 기록', '동아리 활동 예시'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'saenggibu-014',
    category: '생기부',
    topic: '진로 활동 기록 - 학생 맞춤형 작성 전략',
    keywords: ['진로 활동 기록', '진로 생기부', '진로 세특'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'saenggibu-015',
    category: '생기부',
    topic: '자율 활동 기록의 모든 것',
    keywords: ['자율활동 기록', '창체 자율활동', '자율활동 예시'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'saenggibu-016',
    category: '생기부',
    topic: '봉사활동 기록 - 시간만 채우면 끝? NO!',
    keywords: ['봉사활동 기록', '봉사활동 생기부', '봉사 시간'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 2
  },
  {
    id: 'saenggibu-017',
    category: '생기부',
    topic: '생기부 작성 시 개인정보 보호 가이드',
    keywords: ['생기부 개인정보', '학생 개인정보', '생기부 보안'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'saenggibu-018',
    category: '생기부',
    topic: '나이스(NEIS) 생기부 입력 꿀팁',
    keywords: ['나이스 생기부', 'NEIS 입력', '나이스 사용법'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'saenggibu-019',
    category: '생기부',
    topic: '고3 담임의 생기부 작성 전략',
    keywords: ['고3 생기부', '수시 생기부', '대입 생기부'],
    season: 'spring',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'saenggibu-020',
    category: '생기부',
    topic: '초등학교 생기부 vs 중고등학교 생기부 차이점',
    keywords: ['초등 생기부', '중등 생기부', '생기부 차이'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 2
  },

  // ==========================================
  // 📝 수행평가 관련 (25개)
  // ==========================================
  {
    id: 'assessment-001',
    category: '수행평가',
    topic: '수행평가 채점기준표 만드는 법 - 루브릭 작성 가이드',
    keywords: ['수행평가 루브릭', '채점기준표', '서술형 채점'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 5
  },
  {
    id: 'assessment-002',
    category: '수행평가',
    topic: '공정한 수행평가를 위한 채점 전략',
    keywords: ['수행평가 공정성', '채점 기준', '수행평가 객관성'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-003',
    category: '수행평가',
    topic: '학생들이 좋아하는 수행평가 주제 50선',
    keywords: ['수행평가 주제', '수행평가 아이디어', '재미있는 수행평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-004',
    category: '수행평가',
    topic: '수행평가 시간 단축하는 현실적인 방법',
    keywords: ['수행평가 효율', '채점 시간 단축', '수행평가 빨리'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 5
  },
  {
    id: 'assessment-005',
    category: '수행평가',
    topic: '과정중심평가와 수행평가의 연결',
    keywords: ['과정중심평가', '수행평가 과정', '평가 혁신'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'assessment-006',
    category: '수행평가',
    topic: '국어 수행평가 아이디어 20가지',
    keywords: ['국어 수행평가', '글쓰기 수행평가', '발표 수행평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-007',
    category: '수행평가',
    topic: '영어 수행평가 - 말하기/쓰기 평가 설계',
    keywords: ['영어 수행평가', '영어 말하기 평가', '영어 쓰기 평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-008',
    category: '수행평가',
    topic: '수학 수행평가 - 문제해결력 평가 방법',
    keywords: ['수학 수행평가', '수학적 사고력', '문제해결 평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-009',
    category: '수행평가',
    topic: '과학 탐구 수행평가 설계하기',
    keywords: ['과학 수행평가', '탐구 수행평가', '실험 평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-010',
    category: '수행평가',
    topic: '사회 수행평가 - 프로젝트형 평가 가이드',
    keywords: ['사회 수행평가', '프로젝트 평가', '조별 수행평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'assessment-011',
    category: '수행평가',
    topic: '수행평가 민원 대응 - 학부모 설득 전략',
    keywords: ['수행평가 민원', '학부모 민원', '평가 이의제기'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'assessment-012',
    category: '수행평가',
    topic: '온라인 수행평가 도구 추천 TOP 10',
    keywords: ['온라인 수행평가', '디지털 평가 도구', '수행평가 플랫폼'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'assessment-013',
    category: '수행평가',
    topic: '모둠 수행평가에서 무임승차 방지하기',
    keywords: ['모둠 수행평가', '조별 평가', '무임승차 방지'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'assessment-014',
    category: '수행평가',
    topic: '수행평가 피드백 효과적으로 주는 방법',
    keywords: ['수행평가 피드백', '평가 피드백', '학생 피드백'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'assessment-015',
    category: '수행평가',
    topic: '자기평가와 동료평가 활용법',
    keywords: ['자기평가', '동료평가', '상호평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },

  // ==========================================
  // 📚 학습지/시험지 관련 (20개)
  // ==========================================
  {
    id: 'worksheet-001',
    category: '학습지',
    topic: '학습지 만들기 - 효과적인 문제 구성 원칙',
    keywords: ['학습지 만들기', '문제 출제', '학습지 제작'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'worksheet-002',
    category: '학습지',
    topic: '단원평가 문제 출제 요령',
    keywords: ['단원평가', '시험 출제', '평가 문항'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'worksheet-003',
    category: '학습지',
    topic: '난이도별 문제 구성 전략',
    keywords: ['문제 난이도', '변별력', '수준별 학습지'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'worksheet-004',
    category: '학습지',
    topic: '서술형 문항 출제 및 채점 기준',
    keywords: ['서술형 문제', '서술형 채점', '주관식 출제'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'worksheet-005',
    category: '학습지',
    topic: '객관식 선택지 만드는 기술',
    keywords: ['객관식 문제', '선택지 만들기', '오답 선택지'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'worksheet-006',
    category: '학습지',
    topic: '교과서 없이 학습지 만드는 방법',
    keywords: ['학습지 자료', '교재 없이', '자료 수집'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'worksheet-007',
    category: '학습지',
    topic: '중간고사/기말고사 문제 출제 체크리스트',
    keywords: ['중간고사 출제', '기말고사 문제', '시험 출제'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'worksheet-008',
    category: '학습지',
    topic: '초등학생용 학습지 제작 팁',
    keywords: ['초등 학습지', '초등학생 문제', '저학년 학습지'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'worksheet-009',
    category: '학습지',
    topic: '고등학교 수능형 문제 출제 전략',
    keywords: ['수능형 문제', '모의고사 출제', '수능 대비'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'worksheet-010',
    category: '학습지',
    topic: '학습지 디자인 - 가독성 높이는 레이아웃',
    keywords: ['학습지 디자인', '문제지 편집', '학습지 레이아웃'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 2
  },

  // ==========================================
  // 👨‍🏫 학급 운영 (25개)
  // ==========================================
  {
    id: 'classroom-001',
    category: '학급운영',
    topic: '새학기 학급 규칙 세우기 - 학생 참여형',
    keywords: ['학급 규칙', '새학기 준비', '학급 운영'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'classroom-002',
    category: '학급운영',
    topic: '학급 회의 운영 가이드',
    keywords: ['학급 회의', '학급 자치', '회의 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'classroom-003',
    category: '학급운영',
    topic: '문제 행동 학생 지도 전략',
    keywords: ['문제 행동', '학생 지도', '생활지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'classroom-004',
    category: '학급운영',
    topic: '학부모 상담 - 어려운 상황 대처법',
    keywords: ['학부모 상담', '학부모 민원', '상담 요령'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'classroom-005',
    category: '학급운영',
    topic: '학급 분위기 살리는 레크레이션 10선',
    keywords: ['학급 레크', '아이스브레이킹', '학급 놀이'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'classroom-006',
    category: '학급운영',
    topic: '학교폭력 예방 및 대응 매뉴얼',
    keywords: ['학교폭력', '학폭 예방', '학폭 대응'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'classroom-007',
    category: '학급운영',
    topic: '자리 배치의 심리학 - 효과적인 좌석 배열',
    keywords: ['자리 배치', '좌석 배열', '학급 자리'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'classroom-008',
    category: '학급운영',
    topic: '학급 이벤트 기획 - 생일파티부터 졸업식까지',
    keywords: ['학급 이벤트', '학급 행사', '학급 파티'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'classroom-009',
    category: '학급운영',
    topic: '조용한 학생 참여시키는 방법',
    keywords: ['소극적 학생', '수업 참여', '내성적 학생'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'classroom-010',
    category: '학급운영',
    topic: '학급 SNS/단체방 운영 가이드',
    keywords: ['학급 카톡', '학급 SNS', '학부모 단체방'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'classroom-011',
    category: '학급운영',
    topic: '학급 경제 시스템 운영하기 (학급 화폐)',
    keywords: ['학급 경제', '학급 화폐', '보상 시스템'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'classroom-012',
    category: '학급운영',
    topic: '담임 교사의 시간 관리 비법',
    keywords: ['교사 시간관리', '업무 효율', '담임 업무'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },

  // ==========================================
  // ⚖️ 교사 워라밸/업무 효율 (20개)
  // ==========================================
  {
    id: 'worklife-001',
    category: '워라밸',
    topic: '교사 번아웃 예방 - 지속가능한 교직 생활',
    keywords: ['교사 번아웃', '교사 스트레스', '교사 멘탈'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'worklife-002',
    category: '워라밸',
    topic: '칼퇴하는 교사의 비밀 - 업무 효율화 전략',
    keywords: ['교사 칼퇴', '업무 효율', '야근 탈출'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'worklife-003',
    category: '워라밸',
    topic: '행정업무 줄이는 현실적인 방법',
    keywords: ['행정업무', '교사 업무', '업무 경감'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'worklife-004',
    category: '워라밸',
    topic: '공문 처리 빠르게 하는 팁',
    keywords: ['공문 처리', '업무 포털', '행정 효율'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'worklife-005',
    category: '워라밸',
    topic: '교사 자기계발 - 성장하는 교사 되기',
    keywords: ['교사 자기계발', '교사 성장', '전문성 개발'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'worklife-006',
    category: '워라밸',
    topic: '방학 때 해야 할 업무 vs 쉬어야 할 시간',
    keywords: ['방학 업무', '교사 휴식', '방학 계획'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'worklife-007',
    category: '워라밸',
    topic: '교사 커뮤니티 추천 - 동료와 소통하기',
    keywords: ['교사 커뮤니티', '인디스쿨', '교사 모임'],
    season: 'all',
    whatquizLink: '/community',
    priority: 2
  },
  {
    id: 'worklife-008',
    category: '워라밸',
    topic: '교사 연수 선택 가이드 - 시간 낭비 없이',
    keywords: ['교사 연수', '연수 추천', '원격연수'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'worklife-009',
    category: '워라밸',
    topic: '학기말 업무 폭탄 시기 살아남기',
    keywords: ['학기말 업무', '성적 처리', '업무 폭탄'],
    season: 'semester-end',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'worklife-010',
    category: '워라밸',
    topic: '신규 교사 생존 가이드 - 첫 해 현명하게 보내기',
    keywords: ['신규 교사', '초임 교사', '첫 해 교사'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },

  // ==========================================
  // 🤖 AI 활용 교육 (25개)
  // ==========================================
  {
    id: 'ai-001',
    category: 'AI활용',
    topic: 'ChatGPT 수업에 활용하는 10가지 방법',
    keywords: ['ChatGPT 수업', 'AI 수업', 'GPT 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'ai-002',
    category: 'AI활용',
    topic: 'AI로 학습지 만들기 - 5분 만에 완성',
    keywords: ['AI 학습지', 'AI 문제 출제', '자동 학습지'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'ai-003',
    category: 'AI활용',
    topic: 'AI 시대, 학생들에게 가르쳐야 할 것',
    keywords: ['AI 교육', 'AI 리터러시', '미래 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-004',
    category: 'AI활용',
    topic: 'AI 표절 탐지 - 학생 과제 진위 확인',
    keywords: ['AI 표절', 'GPT 탐지', '과제 표절'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-005',
    category: 'AI활용',
    topic: 'Gemini vs ChatGPT vs Claude - 교사용 비교',
    keywords: ['AI 비교', 'Gemini 교육', 'Claude 활용'],
    season: 'all',
    whatquizLink: '/compare/chatgpt',
    priority: 4
  },
  {
    id: 'ai-006',
    category: 'AI활용',
    topic: 'AI로 수업 자료 만들기 - PPT, 영상, 이미지',
    keywords: ['AI PPT', 'AI 수업자료', '자료 제작'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-007',
    category: 'AI활용',
    topic: '학생들과 함께하는 AI 프로젝트 수업',
    keywords: ['AI 프로젝트', 'AI 수업', '학생 AI'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'ai-008',
    category: 'AI활용',
    topic: 'AI 활용 수업 지도안 작성법',
    keywords: ['AI 지도안', 'AI 수업 계획', '수업 설계'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'ai-009',
    category: 'AI활용',
    topic: 'AI 윤리 교육 - 학생들에게 가르쳐야 할 것',
    keywords: ['AI 윤리', 'AI 교육', '디지털 시민'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'ai-010',
    category: 'AI활용',
    topic: '교사를 위한 AI 도구 TOP 20',
    keywords: ['AI 도구', '교사 AI', 'AI 추천'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-011',
    category: 'AI활용',
    topic: 'AI로 채점 시간 줄이기',
    keywords: ['AI 채점', '자동 채점', '채점 효율'],
    season: 'all',
    whatquizLink: '/scoring',
    priority: 5
  },
  {
    id: 'ai-012',
    category: 'AI활용',
    topic: 'AI 이미지 생성으로 수업 자료 만들기',
    keywords: ['AI 이미지', 'DALL-E 교육', '이미지 생성'],
    season: 'all',
    whatquizLink: '/lab/image',
    priority: 3
  },
  {
    id: 'ai-013',
    category: 'AI활용',
    topic: '프롬프트 엔지니어링 - 교사를 위한 가이드',
    keywords: ['프롬프트', 'AI 활용법', 'GPT 잘 쓰는 법'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-014',
    category: 'AI활용',
    topic: 'AI로 가정통신문 작성하기',
    keywords: ['AI 가정통신문', '가정통신문 작성', '알림장'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'ai-015',
    category: 'AI활용',
    topic: 'AI 번역 도구 활용 - 다문화 학생 지도',
    keywords: ['AI 번역', '다문화 교육', '외국인 학생'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 📅 시즌별 콘텐츠 (20개)
  // ==========================================
  {
    id: 'season-001',
    category: '시즌',
    topic: '3월 새학기 준비 체크리스트',
    keywords: ['새학기 준비', '3월 교사', '학기초 준비'],
    season: 'spring',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'season-002',
    category: '시즌',
    topic: '수시 지원 시즌 - 생기부 최종 점검',
    keywords: ['수시 생기부', '대입 준비', '생기부 점검'],
    season: 'fall',
    whatquizLink: '/saenggibu-inspector',
    priority: 5
  },
  {
    id: 'season-003',
    category: '시즌',
    topic: '기말고사 출제 - 놓치기 쉬운 것들',
    keywords: ['기말고사', '시험 출제', '기말 준비'],
    season: 'semester-end',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'season-004',
    category: '시즌',
    topic: '여름방학 업무 정리 가이드',
    keywords: ['여름방학', '방학 업무', '업무 정리'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'season-005',
    category: '시즌',
    topic: '겨울방학 알차게 보내는 법 - 교사편',
    keywords: ['겨울방학', '교사 휴식', '방학 활용'],
    season: 'winter',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'season-006',
    category: '시즌',
    topic: '졸업 시즌 - 생기부 마무리 체크리스트',
    keywords: ['졸업 생기부', '학년말 생기부', '생기부 마감'],
    season: 'winter',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'season-007',
    category: '시즌',
    topic: '중간고사 대비 - 효과적인 복습 수업',
    keywords: ['중간고사', '복습 수업', '시험 대비'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'season-008',
    category: '시즌',
    topic: '신학기 학급 편성 - 담임 배정 후 할 일',
    keywords: ['담임 배정', '학급 편성', '새 학급'],
    season: 'spring',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'season-009',
    category: '시즌',
    topic: '학교폭력 실태조사 시기 - 담임의 역할',
    keywords: ['학폭 실태조사', '학교폭력 조사', '학폭 예방'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'season-010',
    category: '시즌',
    topic: '수능 D-100 - 고3 담임이 해야 할 것',
    keywords: ['수능 준비', '고3 담임', 'D-100'],
    season: 'fall',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },

  // ==========================================
  // 💡 수업 아이디어 (15개)
  // ==========================================
  {
    id: 'lesson-001',
    category: '수업',
    topic: '학생 참여를 높이는 수업 기법 10가지',
    keywords: ['학생 참여', '수업 기법', '참여 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'lesson-002',
    category: '수업',
    topic: '거꾸로 교실(플립러닝) 실전 가이드',
    keywords: ['플립러닝', '거꾸로 수업', '블렌디드'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'lesson-003',
    category: '수업',
    topic: '프로젝트 수업 설계하기',
    keywords: ['프로젝트 수업', 'PBL', '프로젝트 학습'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 3
  },
  {
    id: 'lesson-004',
    category: '수업',
    topic: '토론 수업 운영 노하우',
    keywords: ['토론 수업', '토의 수업', '토론 기법'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'lesson-005',
    category: '수업',
    topic: '협동학습 모형과 실제 적용',
    keywords: ['협동학습', '모둠 수업', '협력 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'lesson-006',
    category: '수업',
    topic: '스마트기기 활용 수업 - 태블릿PC 수업',
    keywords: ['태블릿 수업', '스마트 교육', '디지털 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'lesson-007',
    category: '수업',
    topic: '게이미피케이션 - 게임으로 배우는 수업',
    keywords: ['게이미피케이션', '게임 수업', '퀴즈 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'lesson-008',
    category: '수업',
    topic: '5분 아이스브레이킹 활동 모음',
    keywords: ['아이스브레이킹', '수업 시작', '워밍업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'lesson-009',
    category: '수업',
    topic: '수업 마무리 - 효과적인 정리 활동',
    keywords: ['수업 마무리', '정리 활동', '수업 정리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'lesson-010',
    category: '수업',
    topic: '학습 동기 부여 전략',
    keywords: ['학습 동기', '동기 부여', '학생 동기'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 👨‍👩‍👧 학부모 상담 (35개)
  // ==========================================
  {
    id: 'parent-001',
    category: '학부모상담',
    topic: '학부모 상담 준비 체크리스트',
    keywords: ['학부모상담 준비', '상담 체크리스트', '교사 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'parent-002',
    category: '학부모상담',
    topic: '어려운 학부모 유형별 대응 전략',
    keywords: ['학부모 유형', '학부모 대응', '민원 대응'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'parent-003',
    category: '학부모상담',
    topic: '학부모 상담 대화법 - 공감과 경청',
    keywords: ['상담 대화법', '학부모 소통', '공감 대화'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-004',
    category: '학부모상담',
    topic: '온라인 학부모 상담 효과적으로 하는 법',
    keywords: ['온라인 상담', '비대면 상담', '화상 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-005',
    category: '학부모상담',
    topic: '학부모 민원 예방하는 소통 습관',
    keywords: ['학부모 민원', '민원 예방', '교사 소통'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'parent-006',
    category: '학부모상담',
    topic: '성적 하락 학생 학부모 상담 요령',
    keywords: ['성적 상담', '성적 하락', '학부모 면담'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-007',
    category: '학부모상담',
    topic: '학교폭력 관련 학부모 상담 가이드',
    keywords: ['학폭 상담', '학교폭력 학부모', '피해학생 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'parent-008',
    category: '학부모상담',
    topic: '진로 상담 - 학부모와 학생 의견 조율하기',
    keywords: ['진로 상담', '학부모 진로', '진학 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-009',
    category: '학부모상담',
    topic: '상담 기록 효과적으로 남기는 법',
    keywords: ['상담 기록', '상담 일지', '상담 문서화'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-010',
    category: '학부모상담',
    topic: '학부모 총회 성공적으로 진행하는 법',
    keywords: ['학부모총회', '학부모회의', '총회 준비'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-011',
    category: '학부모상담',
    topic: '1학기 학부모 상담 주간 완벽 준비',
    keywords: ['1학기 상담', '상담 주간', '학부모 면담'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'parent-012',
    category: '학부모상담',
    topic: '2학기 학부모 상담 - 진로와 생기부 중심',
    keywords: ['2학기 상담', '진로 상담', '생기부 상담'],
    season: 'semester-start',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'parent-013',
    category: '학부모상담',
    topic: '특수교육대상 학생 학부모 상담 요령',
    keywords: ['특수교육 상담', '특수학생 학부모', '통합교육 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-014',
    category: '학부모상담',
    topic: '맞벌이 학부모 효과적으로 소통하는 법',
    keywords: ['맞벌이 학부모', '바쁜 학부모', '이메일 소통'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-015',
    category: '학부모상담',
    topic: '학부모에게 좋은 인상 남기는 첫 상담',
    keywords: ['첫 상담', '학부모 첫인상', '신학기 상담'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-016',
    category: '학부모상담',
    topic: '학생 문제행동 학부모에게 전달하는 법',
    keywords: ['문제행동 상담', '학부모 전달', '행동 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-017',
    category: '학부모상담',
    topic: '학부모 상담 후 follow-up 전략',
    keywords: ['상담 후속', '팔로우업', '상담 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-018',
    category: '학부모상담',
    topic: '상담에서 학부모 감정 다루기',
    keywords: ['학부모 감정', '감정 대응', '화난 학부모'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-019',
    category: '학부모상담',
    topic: '학부모 민원 문서로 대응하는 법',
    keywords: ['민원 문서', '공문 대응', '민원 처리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-020',
    category: '학부모상담',
    topic: '긍정적 피드백으로 학부모 신뢰 얻기',
    keywords: ['긍정 피드백', '학부모 신뢰', '칭찬 전달'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-021',
    category: '학부모상담',
    topic: '학부모 SNS 소통 가이드라인',
    keywords: ['학부모 SNS', '카톡 소통', '밴드 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-022',
    category: '학부모상담',
    topic: '학급 운영 방침 학부모에게 설명하기',
    keywords: ['학급 방침', '운영 설명', '학부모 안내'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-023',
    category: '학부모상담',
    topic: '출결 문제 학생 학부모 상담 요령',
    keywords: ['출결 상담', '무단결석', '지각 학생'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-024',
    category: '학부모상담',
    topic: '학부모 공개수업 준비와 진행',
    keywords: ['공개수업', '학부모 참관', '수업 공개'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-025',
    category: '학부모상담',
    topic: '다문화 가정 학부모 소통 전략',
    keywords: ['다문화 상담', '다문화 가정', '언어 장벽'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-026',
    category: '학부모상담',
    topic: '이혼 가정 학생 학부모 상담 유의점',
    keywords: ['이혼 가정', '한부모 상담', '가정환경 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-027',
    category: '학부모상담',
    topic: '학부모 질의에 현명하게 답변하는 법',
    keywords: ['학부모 질문', '질의응답', '상담 답변'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-028',
    category: '학부모상담',
    topic: '학급비/학교 예산 학부모 설명 요령',
    keywords: ['학급비', '예산 설명', '학부모 이해'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-029',
    category: '학부모상담',
    topic: '체험학습/수학여행 학부모 동의 받기',
    keywords: ['체험학습 동의', '수학여행 안내', '학부모 동의'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-030',
    category: '학부모상담',
    topic: '학생 스마트폰/게임 중독 학부모 상담',
    keywords: ['스마트폰 중독', '게임 중독', '미디어 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-031',
    category: '학부모상담',
    topic: '학부모 상담 시간 효율적으로 배분하기',
    keywords: ['상담 시간', '시간 관리', '효율적 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-032',
    category: '학부모상담',
    topic: '학부모 요구 거절하는 현명한 방법',
    keywords: ['학부모 요구', '요구 거절', '합리적 거절'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'parent-033',
    category: '학부모상담',
    topic: '원격수업 관련 학부모 민원 대응',
    keywords: ['원격수업 민원', '온라인 수업 불만', '학부모 민원'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-034',
    category: '학부모상담',
    topic: '졸업 시즌 학부모 감사 인사 전하기',
    keywords: ['졸업 감사', '학부모 인사', '졸업식 소통'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'parent-035',
    category: '학부모상담',
    topic: '학부모와 장기적 신뢰 관계 구축하기',
    keywords: ['학부모 신뢰', '관계 구축', '장기 소통'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },

  // ==========================================
  // 🎪 학교 행사/이벤트 (30개)
  // ==========================================
  {
    id: 'event-001',
    category: '학교행사',
    topic: '입학식 준비 완벽 가이드',
    keywords: ['입학식', '입학식 준비', '신입생 환영'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'event-002',
    category: '학교행사',
    topic: '졸업식 감동적으로 진행하는 법',
    keywords: ['졸업식', '졸업식 준비', '졸업 행사'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'event-003',
    category: '학교행사',
    topic: '체육대회 학급 단합 전략',
    keywords: ['체육대회', '운동회', '학급 단합'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-004',
    category: '학교행사',
    topic: '축제/학예회 학급 공연 준비하기',
    keywords: ['학교 축제', '학예회', '학급 공연'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-005',
    category: '학교행사',
    topic: '수학여행/수련회 교사 생존 가이드',
    keywords: ['수학여행', '수련회', '현장학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'event-006',
    category: '학교행사',
    topic: '현장체험학습 안전하게 진행하는 법',
    keywords: ['현장체험학습', '체험학습 안전', '교외활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-007',
    category: '학교행사',
    topic: '학급 생일파티 간단하게 진행하기',
    keywords: ['생일파티', '학급 생일', '간단한 행사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-008',
    category: '학교행사',
    topic: '어린이날/스승의날 학급 행사 아이디어',
    keywords: ['어린이날', '스승의날', '5월 행사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-009',
    category: '학교행사',
    topic: '할로윈 교실 꾸미기 & 활동 아이디어',
    keywords: ['할로윈', '할로윈 수업', '10월 행사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-010',
    category: '학교행사',
    topic: '크리스마스 학급 파티 준비',
    keywords: ['크리스마스', '연말 행사', '학급 파티'],
    season: 'winter',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-011',
    category: '학교행사',
    topic: '새해/신정 수업 아이디어',
    keywords: ['새해 수업', '신정 활동', '1월 수업'],
    season: 'winter',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-012',
    category: '학교행사',
    topic: '설날 전통문화 수업 진행하기',
    keywords: ['설날 수업', '전통문화', '명절 수업'],
    season: 'winter',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-013',
    category: '학교행사',
    topic: '추석 전통놀이 학급 활동',
    keywords: ['추석 수업', '전통놀이', '명절 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-014',
    category: '학교행사',
    topic: '독서의 달 학급 독서 행사 기획',
    keywords: ['독서의 달', '독서 행사', '9월 독서'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-015',
    category: '학교행사',
    topic: '과학의 날 실험 행사 아이디어',
    keywords: ['과학의 날', '과학 실험', '4월 과학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-016',
    category: '학교행사',
    topic: '환경의 날 학급 캠페인 활동',
    keywords: ['환경의 날', '환경 캠페인', '생태교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-017',
    category: '학교행사',
    topic: '진로박람회 학생 참여 유도하기',
    keywords: ['진로박람회', '직업체험', '진로 탐색'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-018',
    category: '학교행사',
    topic: '학급 종업식/종강파티 진행하기',
    keywords: ['종업식', '종강파티', '학기 마무리'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-019',
    category: '학교행사',
    topic: '학급 사진 예쁘게 촬영하는 법',
    keywords: ['학급사진', '단체사진', '사진 촬영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-020',
    category: '학교행사',
    topic: '학급 영상 제작 가이드 (졸업영상 등)',
    keywords: ['학급영상', '졸업영상', '영상 제작'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-021',
    category: '학교행사',
    topic: '학부모 초청 행사 성공적으로 진행하기',
    keywords: ['학부모 초청', '공개수업', '학부모 행사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-022',
    category: '학교행사',
    topic: '학급 문집/앨범 만들기',
    keywords: ['학급 문집', '학급 앨범', '추억 만들기'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-023',
    category: '학교행사',
    topic: '봉사활동 학급 단위 진행하기',
    keywords: ['봉사활동', '학급 봉사', '사회봉사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-024',
    category: '학교행사',
    topic: '학급 골든벨 퀴즈대회 진행하기',
    keywords: ['골든벨', '퀴즈대회', '학급 게임'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'event-025',
    category: '학교행사',
    topic: '스포츠클럽 대회 준비와 참여',
    keywords: ['스포츠클럽', '학교 대회', '체육 행사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-026',
    category: '학교행사',
    topic: '영어 말하기 대회 학생 지도하기',
    keywords: ['영어대회', '말하기대회', '영어 스피치'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-027',
    category: '학교행사',
    topic: '과학탐구대회 학생 지도 가이드',
    keywords: ['과학탐구대회', '과학대회', '탐구 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-028',
    category: '학교행사',
    topic: '학급 레크리에이션 게임 모음',
    keywords: ['레크리에이션', '학급 게임', '아이스브레이킹'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'event-029',
    category: '학교행사',
    topic: '교내 캠프/야영 안전하게 진행하기',
    keywords: ['교내 캠프', '야영', '캠프 활동'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'event-030',
    category: '학교행사',
    topic: '학급 시상식 의미있게 진행하기',
    keywords: ['시상식', '학급 시상', '표창 행사'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 🧑‍🎓 학생 생활지도 (35개)
  // ==========================================
  {
    id: 'guidance-001',
    category: '생활지도',
    topic: '학교폭력 예방 학급 활동',
    keywords: ['학교폭력 예방', '학폭 예방', '폭력 예방교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-002',
    category: '생활지도',
    topic: '학교폭력 발생 시 교사 대응 매뉴얼',
    keywords: ['학폭 대응', '학교폭력 처리', '학폭 신고'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-003',
    category: '생활지도',
    topic: '사이버 폭력/온라인 괴롭힘 지도',
    keywords: ['사이버폭력', '온라인 괴롭힘', '사이버불링'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-004',
    category: '생활지도',
    topic: '학생 갈등 중재하는 교사의 역할',
    keywords: ['학생 갈등', '갈등 중재', '또래 갈등'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-005',
    category: '생활지도',
    topic: '무단결석 학생 지도 방법',
    keywords: ['무단결석', '결석 지도', '등교 거부'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-006',
    category: '생활지도',
    topic: '지각 습관 학생 개선 전략',
    keywords: ['지각 학생', '지각 지도', '등교 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-007',
    category: '생활지도',
    topic: '수업 중 떠드는 학생 효과적으로 지도하기',
    keywords: ['수업 방해', '떠드는 학생', '수업 집중'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-008',
    category: '생활지도',
    topic: '휴대폰 사용 지도 - 학급 규칙 만들기',
    keywords: ['휴대폰 지도', '스마트폰 규칙', '휴대폰 수거'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-009',
    category: '생활지도',
    topic: '게임 중독 학생 상담과 지도',
    keywords: ['게임 중독', '게임 과몰입', '미디어 중독'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-010',
    category: '생활지도',
    topic: '학생 우울/불안 조기 발견과 대응',
    keywords: ['학생 우울', '학생 불안', '정신건강'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-011',
    category: '생활지도',
    topic: '자해 학생 발견 시 대응 가이드',
    keywords: ['자해 학생', '자해 대응', '위기 개입'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-012',
    category: '생활지도',
    topic: '학생 자살 예방 교육 진행하기',
    keywords: ['자살 예방', '생명존중', '자살예방교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-013',
    category: '생활지도',
    topic: 'Wee클래스/상담실 연계 방법',
    keywords: ['Wee클래스', '학교상담', '상담 연계'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-014',
    category: '생활지도',
    topic: '따돌림 피해 학생 보호와 지원',
    keywords: ['따돌림', '왕따 피해', '피해학생 지원'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'guidance-015',
    category: '생활지도',
    topic: '가해 학생 선도 교육 방법',
    keywords: ['가해 학생', '선도 교육', '행동 교정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-016',
    category: '생활지도',
    topic: '교칙 위반 학생 훈육 방법',
    keywords: ['교칙 위반', '훈육', '규칙 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-017',
    category: '생활지도',
    topic: '흡연 학생 발견 시 대응 절차',
    keywords: ['흡연 학생', '금연 지도', '흡연 예방'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-018',
    category: '생활지도',
    topic: '학교 내 절도 사건 처리 방법',
    keywords: ['학교 절도', '도난 사건', '분실물 처리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-019',
    category: '생활지도',
    topic: '학생 복장/두발 지도 현명하게 하기',
    keywords: ['복장 지도', '두발 규정', '교복 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-020',
    category: '생활지도',
    topic: '급식실 질서 지도 방법',
    keywords: ['급식 지도', '급식실 질서', '점심시간 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-021',
    category: '생활지도',
    topic: '학생 인권 존중하면서 지도하기',
    keywords: ['학생 인권', '인권 존중', '민주적 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-022',
    category: '생활지도',
    topic: '소외 학생 학급에 통합시키기',
    keywords: ['소외 학생', '학급 통합', '또래 관계'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-023',
    category: '생활지도',
    topic: '성교육 효과적으로 진행하는 법',
    keywords: ['성교육', '성폭력 예방', '성인권 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-024',
    category: '생활지도',
    topic: '학생 연애 지도 - 교사의 역할',
    keywords: ['학생 연애', '이성 교제', '연애 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-025',
    category: '생활지도',
    topic: 'ADHD 학생 학급에서 지도하기',
    keywords: ['ADHD 학생', '주의력결핍', 'ADHD 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-026',
    category: '생활지도',
    topic: '발달장애 학생 통합학급 지도',
    keywords: ['발달장애', '통합학급', '특수학생 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-027',
    category: '생활지도',
    topic: '경계선 지능 학생 지원 방법',
    keywords: ['경계선 지능', '느린 학습자', '학습 지원'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-028',
    category: '생활지도',
    topic: '다문화 학생 학급 적응 돕기',
    keywords: ['다문화 학생', '이중언어', '문화 적응'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-029',
    category: '생활지도',
    topic: '전학생 학급 적응 지원하기',
    keywords: ['전학생', '전학 적응', '새 학급 적응'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-030',
    category: '생활지도',
    topic: '학급 규칙 학생과 함께 만들기',
    keywords: ['학급 규칙', '학급 약속', '규칙 제정'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-031',
    category: '생활지도',
    topic: '학생 자치 활동 활성화 방법',
    keywords: ['학생 자치', '학급 자치', '자치 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-032',
    category: '생활지도',
    topic: '학생 리더십 교육 진행하기',
    keywords: ['학생 리더십', '리더 교육', '반장 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'guidance-033',
    category: '생활지도',
    topic: '학교 안전사고 예방과 대응',
    keywords: ['안전사고', '학교 안전', '사고 예방'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-034',
    category: '생활지도',
    topic: '학생 스트레스 해소 프로그램',
    keywords: ['학생 스트레스', '스트레스 해소', '마음건강'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'guidance-035',
    category: '생활지도',
    topic: '시험 불안 학생 지도 방법',
    keywords: ['시험 불안', '시험 스트레스', '시험 공포'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },

  // ==========================================
  // 📘 교과별 수업 (60개)
  // ==========================================
  {
    id: 'subject-001',
    category: '국어수업',
    topic: '국어 독서 수업 재미있게 하는 법',
    keywords: ['국어 독서', '독서 수업', '읽기 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-002',
    category: '국어수업',
    topic: '국어 글쓰기 지도 - 단계별 접근',
    keywords: ['글쓰기 지도', '작문 수업', '쓰기 교육'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-003',
    category: '국어수업',
    topic: '국어 문법 수업 쉽게 가르치기',
    keywords: ['국어 문법', '문법 수업', '문법 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-004',
    category: '국어수업',
    topic: '시 수업 학생들이 즐기게 만들기',
    keywords: ['시 수업', '시 감상', '문학 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-005',
    category: '국어수업',
    topic: '소설 수업 토론으로 진행하기',
    keywords: ['소설 수업', '문학 토론', '소설 읽기'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-006',
    category: '국어수업',
    topic: '국어 발표 수업 효과적으로 진행하기',
    keywords: ['발표 수업', '말하기 지도', '스피치 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-007',
    category: '영어수업',
    topic: '영어 스피킹 수업 활성화 전략',
    keywords: ['영어 스피킹', '영어 말하기', 'Speaking 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'subject-008',
    category: '영어수업',
    topic: '영어 듣기 수업 효과적으로 진행하기',
    keywords: ['영어 듣기', 'Listening 수업', '청해 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-009',
    category: '영어수업',
    topic: '영어 읽기 수업 - 독해력 키우기',
    keywords: ['영어 읽기', 'Reading 수업', '영어 독해'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-010',
    category: '영어수업',
    topic: '영어 쓰기 수업 단계별 지도',
    keywords: ['영어 쓰기', 'Writing 수업', '영작문'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-011',
    category: '영어수업',
    topic: '영어 문법 쉽게 설명하는 법',
    keywords: ['영어 문법', 'Grammar 수업', '문법 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-012',
    category: '영어수업',
    topic: '영어 단어 효과적으로 암기시키기',
    keywords: ['영어 단어', '어휘 암기', 'Vocabulary'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-013',
    category: '영어수업',
    topic: '영어 수업에 게임 활용하기',
    keywords: ['영어 게임', '영어 활동', '재미있는 영어'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-014',
    category: '수학수업',
    topic: '수학 개념 쉽게 설명하는 비법',
    keywords: ['수학 개념', '수학 설명', '개념 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'subject-015',
    category: '수학수업',
    topic: '수학 문제풀이 수업 효과적으로',
    keywords: ['수학 문제풀이', '수학 연습', '문제 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-016',
    category: '수학수업',
    topic: '수학 포기 학생 살리는 수업 전략',
    keywords: ['수포자', '수학 포기', '기초 수학'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'subject-017',
    category: '수학수업',
    topic: '수학 수업에 조작 활동 활용하기',
    keywords: ['수학 조작', '교구 활용', '체험 수학'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-018',
    category: '수학수업',
    topic: '수학적 사고력 키우는 수업 방법',
    keywords: ['수학적 사고', '사고력 수학', '문제해결력'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-019',
    category: '수학수업',
    topic: '수학 서술형 평가 지도하기',
    keywords: ['수학 서술형', '서술형 평가', '수학 작성'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-020',
    category: '수학수업',
    topic: '실생활 연계 수학 수업 아이디어',
    keywords: ['실생활 수학', '수학 활용', '생활 속 수학'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-021',
    category: '과학수업',
    topic: '과학 실험 안전하게 진행하기',
    keywords: ['과학 실험', '실험 안전', '실험 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-022',
    category: '과학수업',
    topic: '과학 탐구 수업 설계하기',
    keywords: ['과학 탐구', '탐구학습', '탐구 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-023',
    category: '과학수업',
    topic: '과학 개념 시각화하여 가르치기',
    keywords: ['과학 시각화', '과학 개념', '개념 설명'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-024',
    category: '과학수업',
    topic: '과학 수업에 영상 활용하기',
    keywords: ['과학 영상', '과학 동영상', '멀티미디어 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-025',
    category: '과학수업',
    topic: '환경/생태 교육 수업 아이디어',
    keywords: ['환경 교육', '생태 교육', '환경 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-026',
    category: '사회수업',
    topic: '사회 수업에 시사 뉴스 활용하기',
    keywords: ['시사 수업', '뉴스 활용', '사회 이슈'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-027',
    category: '사회수업',
    topic: '역사 수업 흥미롭게 진행하기',
    keywords: ['역사 수업', '한국사', '역사 이야기'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'subject-028',
    category: '사회수업',
    topic: '지리 수업 체험으로 배우기',
    keywords: ['지리 수업', '지도 활용', '지역 학습'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-029',
    category: '사회수업',
    topic: '경제 교육 쉽게 가르치기',
    keywords: ['경제 교육', '경제 수업', '금융 교육'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-030',
    category: '사회수업',
    topic: '민주시민 교육 수업 설계',
    keywords: ['민주시민', '시민 교육', '민주주의 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-031',
    category: '사회수업',
    topic: '사회 수업 토론/토의 진행법',
    keywords: ['사회 토론', '토의 수업', '사회 토의'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-032',
    category: '음악수업',
    topic: '음악 수업 즐겁게 진행하기',
    keywords: ['음악 수업', '음악 활동', '음악 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-033',
    category: '음악수업',
    topic: '악기 수업 효과적으로 지도하기',
    keywords: ['악기 수업', '리코더 지도', '악기 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-034',
    category: '음악수업',
    topic: '합창 수업 학급 단위로 진행하기',
    keywords: ['합창 수업', '합창 지도', '노래 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-035',
    category: '미술수업',
    topic: '미술 수업 다양한 재료 활용하기',
    keywords: ['미술 재료', '미술 활동', '창작 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-036',
    category: '미술수업',
    topic: '미술 감상 수업 진행 방법',
    keywords: ['미술 감상', '작품 감상', '미술 비평'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-037',
    category: '미술수업',
    topic: '디지털 미술 수업 진행하기',
    keywords: ['디지털 미술', '태블릿 미술', '디지털 아트'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-038',
    category: '체육수업',
    topic: '체육 수업 안전하게 진행하기',
    keywords: ['체육 안전', '체육 수업', '운동 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-039',
    category: '체육수업',
    topic: '실내 체육 활동 아이디어',
    keywords: ['실내 체육', '강당 활동', '우천 체육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-040',
    category: '체육수업',
    topic: '체육 싫어하는 학생 참여시키기',
    keywords: ['체육 기피', '운동 싫어하는 학생', '체육 참여'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-041',
    category: '체육수업',
    topic: '뉴스포츠 수업 도입하기',
    keywords: ['뉴스포츠', '새로운 스포츠', '체육 다양화'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-042',
    category: '정보수업',
    topic: '코딩 교육 처음 시작하기',
    keywords: ['코딩 교육', '프로그래밍 수업', 'SW 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-043',
    category: '정보수업',
    topic: '스크래치로 창의적 프로젝트 만들기',
    keywords: ['스크래치', 'Scratch 수업', '블록 코딩'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-044',
    category: '정보수업',
    topic: '파이썬 기초 수업 진행하기',
    keywords: ['파이썬', 'Python 수업', '텍스트 코딩'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-045',
    category: '정보수업',
    topic: 'AI 교육 수업 설계하기',
    keywords: ['AI 교육', '인공지능 수업', 'AI 리터러시'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-046',
    category: '정보수업',
    topic: '디지털 리터러시 교육 방법',
    keywords: ['디지털 리터러시', '미디어 리터러시', '정보 활용'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-047',
    category: '도덕수업',
    topic: '도덕 수업 토론으로 진행하기',
    keywords: ['도덕 토론', '윤리 수업', '가치 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-048',
    category: '도덕수업',
    topic: '인성 교육 효과적으로 하는 법',
    keywords: ['인성 교육', '인성 수업', '인격 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-049',
    category: '도덕수업',
    topic: '생명존중 교육 진행하기',
    keywords: ['생명존중', '생명 교육', '생명 윤리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-050',
    category: '실과수업',
    topic: '가정생활 영역 실습 수업',
    keywords: ['가정 실습', '요리 수업', '생활 실습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-051',
    category: '실과수업',
    topic: '기술 영역 만들기 수업',
    keywords: ['기술 실습', '만들기 수업', '제작 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-052',
    category: '제2외국어',
    topic: '일본어 첫 수업 흥미롭게 시작하기',
    keywords: ['일본어 수업', '일본어 입문', '일본어 첫 시간'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-053',
    category: '제2외국어',
    topic: '중국어 발음 쉽게 가르치기',
    keywords: ['중국어 수업', '중국어 발음', '성조 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'subject-054',
    category: '진로수업',
    topic: '진로 탐색 수업 설계하기',
    keywords: ['진로 탐색', '진로 수업', '직업 탐색'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-055',
    category: '진로수업',
    topic: '진로 검사 결과 해석 수업',
    keywords: ['진로 검사', '적성 검사', '진로 해석'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-056',
    category: '진로수업',
    topic: '다양한 직업 소개 수업',
    keywords: ['직업 소개', '직업 탐구', '미래 직업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-057',
    category: '창체수업',
    topic: '창의적 체험활동 아이디어 모음',
    keywords: ['창체', '창의적 체험활동', '창체 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-058',
    category: '창체수업',
    topic: '동아리 활동 운영 가이드',
    keywords: ['동아리', '동아리 운영', '학교 동아리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'subject-059',
    category: '창체수업',
    topic: '봉사활동 의미있게 진행하기',
    keywords: ['봉사활동', '봉사 교육', '사회봉사'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'subject-060',
    category: '창체수업',
    topic: '자율활동 프로그램 기획하기',
    keywords: ['자율활동', '학급 자율', '자율 프로그램'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 🎯 진로/진학 지도 (35개)
  // ==========================================
  {
    id: 'career-001',
    category: '진로진학',
    topic: '고입 지도 - 특목고/자사고 준비',
    keywords: ['고입', '특목고', '자사고 준비'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-002',
    category: '진로진학',
    topic: '대입 수시 지도 완벽 가이드',
    keywords: ['수시', '학생부종합', '수시 준비'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'career-003',
    category: '진로진학',
    topic: '대입 정시 지도 - 수능 전략',
    keywords: ['정시', '수능', '정시 준비'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-004',
    category: '진로진학',
    topic: '자기소개서 지도하는 법',
    keywords: ['자기소개서', '자소서 지도', '대입 자소서'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'career-005',
    category: '진로진학',
    topic: '면접 지도 - 대입/취업 대비',
    keywords: ['면접 지도', '면접 준비', '면접 연습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-006',
    category: '진로진학',
    topic: '학종 세특 연계 진학 지도',
    keywords: ['학종', '세특 연계', '학생부종합'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'career-007',
    category: '진로진학',
    topic: '진로희망 사항 작성 지도',
    keywords: ['진로희망', '진로 기록', '진로 작성'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'career-008',
    category: '진로진학',
    topic: '대학 학과 탐색 수업 진행하기',
    keywords: ['학과 탐색', '대학 학과', '전공 탐색'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-009',
    category: '진로진학',
    topic: '전문대학/폴리텍 진학 지도',
    keywords: ['전문대', '폴리텍', '전문대학 진학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-010',
    category: '진로진학',
    topic: '취업 진로 학생 지도하기',
    keywords: ['취업 진로', '고졸 취업', '취업 준비'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-011',
    category: '진로진학',
    topic: '해외 대학 진학 상담 기초',
    keywords: ['해외 대학', '유학 상담', '해외 진학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-012',
    category: '진로진학',
    topic: '학생 진로 적성 파악하기',
    keywords: ['진로 적성', '적성 검사', '진로 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-013',
    category: '진로진학',
    topic: '진로 미결정 학생 상담하기',
    keywords: ['진로 미결정', '진로 고민', '진로 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-014',
    category: '진로진학',
    topic: '미래 유망 직업 정보 제공하기',
    keywords: ['미래 직업', '유망 직업', '신직업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-015',
    category: '진로진학',
    topic: '진로 포트폴리오 제작 지도',
    keywords: ['진로 포트폴리오', '포트폴리오 작성', '활동 정리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-016',
    category: '진로진학',
    topic: '커리어넷 활용 수업하기',
    keywords: ['커리어넷', '진로 사이트', '진로 자료'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-017',
    category: '진로진학',
    topic: '직업 체험 프로그램 운영하기',
    keywords: ['직업 체험', '직업 탐방', '현장 체험'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-018',
    category: '진로진학',
    topic: '진로 멘토링 프로그램 운영',
    keywords: ['진로 멘토링', '직업인 멘토', '진로 연결'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-019',
    category: '진로진학',
    topic: '입시 설명회 준비와 진행',
    keywords: ['입시 설명회', '진학 설명회', '학부모 설명'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-020',
    category: '진로진학',
    topic: '원서 접수 지도 체크리스트',
    keywords: ['원서 접수', '원서 지도', '대학 원서'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'career-021',
    category: '진로진학',
    topic: '예체능 진학 특수 지도',
    keywords: ['예체능 진학', '음대 입시', '미대 입시'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-022',
    category: '진로진학',
    topic: '사관학교/경찰대 진학 지도',
    keywords: ['사관학교', '경찰대', '특수대학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-023',
    category: '진로진학',
    topic: '교대/사범대 진학 지도',
    keywords: ['교대', '사범대', '교육대학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-024',
    category: '진로진학',
    topic: '의대/치대/한의대 진학 지도',
    keywords: ['의대', '의학계열', '의치한'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-025',
    category: '진로진학',
    topic: '창업/스타트업 진로 수업',
    keywords: ['창업 교육', '스타트업', '기업가 정신'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-026',
    category: '진로진학',
    topic: '진로 독서 활동 지도하기',
    keywords: ['진로 독서', '진로 관련 도서', '독서 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-027',
    category: '진로진학',
    topic: '학생 강점 발견하고 키워주기',
    keywords: ['학생 강점', '강점 발견', '재능 계발'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-028',
    category: '진로진학',
    topic: '대학 전형 분석하는 법',
    keywords: ['대학 전형', '입시 분석', '전형 이해'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-029',
    category: '진로진학',
    topic: '지역 인재 전형 활용 지도',
    keywords: ['지역 인재', '지역 전형', '지역 우대'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-030',
    category: '진로진학',
    topic: '학생 진로 상담 기록 남기기',
    keywords: ['상담 기록', '진로 기록', '상담 관리'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 3
  },
  {
    id: 'career-031',
    category: '진로진학',
    topic: 'AI 시대 진로 교육 방향',
    keywords: ['AI 진로', '미래 교육', '진로 변화'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-032',
    category: '진로진학',
    topic: '진로캠프 기획과 운영',
    keywords: ['진로캠프', '진로 행사', '캠프 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-033',
    category: '진로진학',
    topic: '반수/재수 학생 상담하기',
    keywords: ['반수', '재수', '재수생 상담'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'career-034',
    category: '진로진학',
    topic: '진학 실패 학생 정서 지원',
    keywords: ['진학 실패', '불합격 상담', '정서 지원'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'career-035',
    category: '진로진학',
    topic: '졸업 후 진로 추적 관리',
    keywords: ['졸업 후 진로', '진로 추적', '졸업생 관리'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 2
  },

  // ==========================================
  // 🎒 학교급별 특화 (45개)
  // ==========================================
  {
    id: 'elementary-001',
    category: '초등',
    topic: '초등 1학년 학교 적응 프로그램',
    keywords: ['초1 적응', '1학년 프로그램', '학교 적응'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'elementary-002',
    category: '초등',
    topic: '초등 저학년 기초학력 지도',
    keywords: ['기초학력', '저학년 학력', '기초 지도'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 5
  },
  {
    id: 'elementary-003',
    category: '초등',
    topic: '초등 놀이 중심 수업 설계',
    keywords: ['놀이 수업', '놀이 학습', '놀이 중심'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'elementary-004',
    category: '초등',
    topic: '초등 알림장 효과적으로 활용하기',
    keywords: ['알림장', '알림장 작성', '가정통신'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-005',
    category: '초등',
    topic: '초등 급식 지도 요령',
    keywords: ['초등 급식', '급식 지도', '점심시간'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-006',
    category: '초등',
    topic: '초등 교실 환경 구성 아이디어',
    keywords: ['교실 환경', '환경 구성', '교실 꾸미기'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'elementary-007',
    category: '초등',
    topic: '초등 담임 1년 운영 로드맵',
    keywords: ['담임 운영', '학급 1년', '담임 계획'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'elementary-008',
    category: '초등',
    topic: '초등 방과후학교 운영하기',
    keywords: ['방과후학교', '방과후', '방과후 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-009',
    category: '초등',
    topic: '초등 돌봄교실 효과적 운영',
    keywords: ['돌봄교실', '초등돌봄', '방과후돌봄'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-010',
    category: '초등',
    topic: '초등 아침활동 프로그램 아이디어',
    keywords: ['아침활동', '아침 시간', '등교 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-011',
    category: '초등',
    topic: '초등 체험학습 안전하게 다녀오기',
    keywords: ['초등 체험학습', '현장학습', '교외 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'elementary-012',
    category: '초등',
    topic: '초등 학부모 소통 노하우',
    keywords: ['초등 학부모', '학부모 소통', '초등 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'elementary-013',
    category: '초등',
    topic: '초등 고학년 사춘기 지도',
    keywords: ['초등 사춘기', '고학년 지도', '5-6학년'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'elementary-014',
    category: '초등',
    topic: '초등 학급 회의 진행하기',
    keywords: ['학급 회의', '초등 자치', '학급 토론'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'elementary-015',
    category: '초등',
    topic: '초등 6학년 졸업 프로젝트',
    keywords: ['6학년 졸업', '초등 졸업', '졸업 프로젝트'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-001',
    category: '중등',
    topic: '중1 신입생 학교 적응 프로그램',
    keywords: ['중1 적응', '중학교 적응', '신입생 적응'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'middle-002',
    category: '중등',
    topic: '중학생 사춘기 이해와 소통',
    keywords: ['중학생 사춘기', '청소년 이해', '사춘기 소통'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'middle-003',
    category: '중등',
    topic: '자유학기제 수업 설계하기',
    keywords: ['자유학기제', '자유학년제', '자유학기 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-004',
    category: '중등',
    topic: '중학교 교과 담임 효과적 운영',
    keywords: ['교과 담임', '중학교 담임', '교과 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-005',
    category: '중등',
    topic: '중학교 동아리 활동 활성화',
    keywords: ['중학교 동아리', '동아리 운영', '자율동아리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'middle-006',
    category: '중등',
    topic: '중3 고입 진학 지도',
    keywords: ['중3 진학', '고입', '고등학교 입학'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-007',
    category: '중등',
    topic: '중학교 내신 관리 지도',
    keywords: ['중학교 내신', '내신 관리', '성적 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-008',
    category: '중등',
    topic: '중학생 또래 관계 지도',
    keywords: ['또래 관계', '친구 관계', '중학생 우정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-009',
    category: '중등',
    topic: '중학교 생기부 작성 가이드',
    keywords: ['중학교 생기부', '중등 생기부', '중학교 기록'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 4
  },
  {
    id: 'middle-010',
    category: '중등',
    topic: '중학교 진로 교육 방향',
    keywords: ['중학교 진로', '진로 탐색', '중등 진로'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-011',
    category: '중등',
    topic: '중학생 학습 습관 형성 지도',
    keywords: ['학습 습관', '공부 습관', '자기주도학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-012',
    category: '중등',
    topic: '중학교 체험학습 운영하기',
    keywords: ['중학교 체험학습', '현장학습', '수학여행'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'middle-013',
    category: '중등',
    topic: '중학교 학부모 상담 요령',
    keywords: ['중학교 상담', '학부모 면담', '진로 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-014',
    category: '중등',
    topic: '중학교 학급 경영 노하우',
    keywords: ['중학교 학급', '학급 경영', '담임 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'middle-015',
    category: '중등',
    topic: '중학교 봉사활동 프로그램',
    keywords: ['중학교 봉사', '봉사활동 시간', '봉사 기록'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'high-001',
    category: '고등',
    topic: '고1 학교생활 적응 프로그램',
    keywords: ['고1 적응', '고등학교 적응', '신입생 지도'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'high-002',
    category: '고등',
    topic: '고등학교 내신 관리 전략',
    keywords: ['고등 내신', '내신 관리', '내신 성적'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'high-003',
    category: '고등',
    topic: '수능 대비 학습 지도',
    keywords: ['수능 대비', '수능 준비', '수능 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'high-004',
    category: '고등',
    topic: '고3 담임 생존 가이드',
    keywords: ['고3 담임', '수험생 지도', '고3 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'high-005',
    category: '고등',
    topic: '고등학교 선택과목 지도',
    keywords: ['선택과목', '과목 선택', '교육과정 설계'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-006',
    category: '고등',
    topic: '고등학교 세특 전략적 작성',
    keywords: ['고등 세특', '학종 세특', '전략적 세특'],
    season: 'all',
    whatquizLink: '/create-saenggibu',
    priority: 5
  },
  {
    id: 'high-007',
    category: '고등',
    topic: '고등학생 스트레스 관리 지도',
    keywords: ['수험 스트레스', '학업 스트레스', '스트레스 해소'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-008',
    category: '고등',
    topic: '고등학교 야자/보충 수업 운영',
    keywords: ['야자', '보충수업', '자율학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'high-009',
    category: '고등',
    topic: '고등학교 동아리 대입 연계',
    keywords: ['고등 동아리', '동아리 대입', '비교과 활동'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-010',
    category: '고등',
    topic: '고등학교 수행평가 공정하게 운영',
    keywords: ['고등 수행평가', '수행 채점', '평가 공정성'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'high-011',
    category: '고등',
    topic: '수시 원서 지도 체크리스트',
    keywords: ['수시 원서', '원서 지도', '대입 원서'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'high-012',
    category: '고등',
    topic: '수능 D-100 학급 운영',
    keywords: ['D-100', '수능 직전', '수험생 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-013',
    category: '고등',
    topic: '수능 당일 담임 역할',
    keywords: ['수능 당일', '수능일', '담임 업무'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-014',
    category: '고등',
    topic: '고등학교 학부모 진학 상담',
    keywords: ['진학 상담', '학부모 입시', '대입 상담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'high-015',
    category: '고등',
    topic: '고등학교 졸업식 의미있게 준비하기',
    keywords: ['고등 졸업식', '졸업 행사', '졸업 준비'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 📑 학교 행정/공문 (30개)
  // ==========================================
  {
    id: 'admin-001',
    category: '행정',
    topic: '학교 공문 효율적으로 처리하기',
    keywords: ['공문 처리', '나이스 공문', '행정 업무'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'admin-002',
    category: '행정',
    topic: '나이스 시스템 활용 가이드',
    keywords: ['나이스', 'NEIS', '나이스 사용법'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'admin-003',
    category: '행정',
    topic: '학급 예산 관리하는 법',
    keywords: ['학급 예산', '학급비', '예산 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-004',
    category: '행정',
    topic: '출결 처리 완벽 가이드',
    keywords: ['출결 처리', '출석부', '결석 처리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'admin-005',
    category: '행정',
    topic: '학교폭력 업무 처리 절차',
    keywords: ['학폭 업무', '학교폭력 처리', '학폭 절차'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'admin-006',
    category: '행정',
    topic: '성적 처리 실수 없이 하는 법',
    keywords: ['성적 처리', '성적 입력', '성적 관리'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'admin-007',
    category: '행정',
    topic: '가정통신문 효과적으로 작성하기',
    keywords: ['가정통신문', '통신문 작성', '학부모 안내'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-008',
    category: '행정',
    topic: '현장체험학습 공문 서류 준비',
    keywords: ['체험학습 서류', '현장학습 공문', '행정 준비'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-009',
    category: '행정',
    topic: '학기 말 서류 마감 체크리스트',
    keywords: ['학기말 서류', '마감 체크', '행정 마감'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'admin-010',
    category: '행정',
    topic: '신학기 서류 준비 가이드',
    keywords: ['신학기 서류', '학기 시작', '행정 준비'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'admin-011',
    category: '행정',
    topic: '교육청 감사 대비 서류 정리',
    keywords: ['교육청 감사', '서류 정리', '감사 대비'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-012',
    category: '행정',
    topic: '학적 변동 업무 처리하기',
    keywords: ['학적 변동', '전학', '학적 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-013',
    category: '행정',
    topic: '방학 중 업무 효율적으로 처리하기',
    keywords: ['방학 업무', '방학 중 일', '방학 행정'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-014',
    category: '행정',
    topic: '학급 명렬표/좌석표 관리',
    keywords: ['명렬표', '좌석표', '학급 관리'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-015',
    category: '행정',
    topic: '학교 정보공시 업무 이해하기',
    keywords: ['정보공시', '학교알리미', '공시 업무'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'admin-016',
    category: '행정',
    topic: '교무업무 시스템 활용 팁',
    keywords: ['교무업무', '업무시스템', '행정시스템'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-017',
    category: '행정',
    topic: '교원 연수 이수 관리하기',
    keywords: ['교원 연수', '연수 이수', '직무연수'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-018',
    category: '행정',
    topic: '학교 안전 점검 체크리스트',
    keywords: ['안전 점검', '학교 안전', '안전 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-019',
    category: '행정',
    topic: '교육과정 운영 문서 작성하기',
    keywords: ['교육과정', '교육과정 문서', '운영 계획'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-020',
    category: '행정',
    topic: '학교운영위원회 업무 이해하기',
    keywords: ['운영위원회', '학운위', '학교 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'admin-021',
    category: '행정',
    topic: '교사 업무 분장 효율적으로 하기',
    keywords: ['업무 분장', '업무 배분', '교사 업무'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-022',
    category: '행정',
    topic: '졸업장/수료증 발급 업무',
    keywords: ['졸업장', '수료증', '증명서 발급'],
    season: 'semester-end',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-023',
    category: '행정',
    topic: '학교 예산 집행 이해하기',
    keywords: ['학교 예산', '예산 집행', '학교 재정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'admin-024',
    category: '행정',
    topic: '교구/교재 구입 절차',
    keywords: ['교구 구입', '교재 구입', '물품 구매'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-025',
    category: '행정',
    topic: '출장/연수 서류 처리하기',
    keywords: ['출장 서류', '연수 신청', '출장 처리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-026',
    category: '행정',
    topic: '개인정보 보호 업무 가이드',
    keywords: ['개인정보', '정보보호', '개인정보 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-027',
    category: '행정',
    topic: '학교 홈페이지 관리하기',
    keywords: ['학교 홈페이지', '홈페이지 관리', '웹사이트 운영'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'admin-028',
    category: '행정',
    topic: '학교 SNS/밴드 운영 가이드',
    keywords: ['학교 SNS', '학교 밴드', '소통 채널'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'admin-029',
    category: '행정',
    topic: '민원 응대 매뉴얼',
    keywords: ['민원 응대', '민원 처리', '민원 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'admin-030',
    category: '행정',
    topic: '학교 행사 예산 기획하기',
    keywords: ['행사 예산', '행사 기획', '예산 계획'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 🌐 원격/온라인 수업 (25개)
  // ==========================================
  {
    id: 'online-001',
    category: '온라인수업',
    topic: '줌(Zoom) 수업 효과적으로 진행하기',
    keywords: ['줌 수업', 'Zoom', '화상 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'online-002',
    category: '온라인수업',
    topic: '구글 클래스룸 활용 가이드',
    keywords: ['구글 클래스룸', 'Google Classroom', '온라인 학급'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'online-003',
    category: '온라인수업',
    topic: 'MS Teams 수업 운영하기',
    keywords: ['MS Teams', '팀즈', '마이크로소프트'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-004',
    category: '온라인수업',
    topic: '클래스팅 효과적으로 활용하기',
    keywords: ['클래스팅', 'Classting', '학급 SNS'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-005',
    category: '온라인수업',
    topic: 'e학습터 수업 콘텐츠 만들기',
    keywords: ['e학습터', '이학습터', 'EBS 연계'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-006',
    category: '온라인수업',
    topic: '온라인 출석 체크 방법',
    keywords: ['온라인 출석', '원격 출결', '비대면 출석'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'online-007',
    category: '온라인수업',
    topic: '온라인 수업 학생 참여 높이기',
    keywords: ['온라인 참여', '비대면 참여', '수업 집중'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'online-008',
    category: '온라인수업',
    topic: '온라인 수행평가 공정하게 진행하기',
    keywords: ['온라인 평가', '원격 평가', '비대면 수행평가'],
    season: 'all',
    whatquizLink: '/assessment-plan',
    priority: 4
  },
  {
    id: 'online-009',
    category: '온라인수업',
    topic: '블렌디드 러닝 수업 설계',
    keywords: ['블렌디드 러닝', '혼합 학습', '온오프라인'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'online-010',
    category: '온라인수업',
    topic: '플립드 러닝 수업 진행하기',
    keywords: ['플립드 러닝', '거꾸로 수업', '역진행 수업'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'online-011',
    category: '온라인수업',
    topic: '수업 영상 쉽게 제작하기',
    keywords: ['수업 영상', '동영상 제작', '강의 녹화'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-012',
    category: '온라인수업',
    topic: '패들렛 수업에 활용하기',
    keywords: ['패들렛', 'Padlet', '온라인 협업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-013',
    category: '온라인수업',
    topic: '멘티미터로 상호작용 수업하기',
    keywords: ['멘티미터', 'Mentimeter', '실시간 퀴즈'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 3
  },
  {
    id: 'online-014',
    category: '온라인수업',
    topic: '카훗으로 재미있는 퀴즈 수업',
    keywords: ['카훗', 'Kahoot', '퀴즈 게임'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'online-015',
    category: '온라인수업',
    topic: '잼보드 협업 수업 진행하기',
    keywords: ['잼보드', 'Jamboard', '온라인 화이트보드'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-016',
    category: '온라인수업',
    topic: '노션으로 학급 운영하기',
    keywords: ['노션', 'Notion', '디지털 학급'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-017',
    category: '온라인수업',
    topic: '미리캔버스 수업 자료 만들기',
    keywords: ['미리캔버스', '디자인 툴', '수업 자료'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-018',
    category: '온라인수업',
    topic: '캔바 교육용 활용 가이드',
    keywords: ['캔바', 'Canva', '교육용 캔바'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-019',
    category: '온라인수업',
    topic: '온라인 그룹 활동 진행하기',
    keywords: ['온라인 그룹', '비대면 모둠', '협력 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-020',
    category: '온라인수업',
    topic: '온라인 수업 저작권 주의사항',
    keywords: ['온라인 저작권', '수업 저작권', '자료 활용'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-021',
    category: '온라인수업',
    topic: '화상 수업 환경 세팅하기',
    keywords: ['화상 환경', '수업 세팅', '온라인 환경'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-022',
    category: '온라인수업',
    topic: '비대면 학부모 상담 진행하기',
    keywords: ['비대면 상담', '온라인 상담', '화상 면담'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-023',
    category: '온라인수업',
    topic: '온라인 과제 효과적으로 관리하기',
    keywords: ['온라인 과제', '과제 관리', '과제 피드백'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'online-024',
    category: '온라인수업',
    topic: 'OBS 스트리밍 수업하기',
    keywords: ['OBS', '스트리밍', '라이브 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'online-025',
    category: '온라인수업',
    topic: '온라인 학급 문화 만들기',
    keywords: ['온라인 학급', '비대면 문화', '디지털 학급'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 🔮 교육 트렌드 2026 (25개)
  // ==========================================
  {
    id: 'trend-001',
    category: '교육트렌드',
    topic: '2026 교육과정 변화 총정리',
    keywords: ['2026 교육과정', '교육과정 변화', '새 교육과정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'trend-002',
    category: '교육트렌드',
    topic: 'AI 디지털 교과서 활용 가이드',
    keywords: ['AI 교과서', '디지털 교과서', '스마트 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'trend-003',
    category: '교육트렌드',
    topic: 'IB 교육 한국 학교에 적용하기',
    keywords: ['IB 교육', 'IB 프로그램', '국제 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-004',
    category: '교육트렌드',
    topic: '고교학점제 운영 가이드',
    keywords: ['고교학점제', '학점제', '선택 교육과정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'trend-005',
    category: '교육트렌드',
    topic: '프로젝트 기반 학습(PBL) 설계',
    keywords: ['PBL', '프로젝트 학습', '프로젝트 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-006',
    category: '교육트렌드',
    topic: '메타버스 교육 활용 사례',
    keywords: ['메타버스', '가상현실 교육', 'VR 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-007',
    category: '교육트렌드',
    topic: '게이미피케이션 수업 적용하기',
    keywords: ['게이미피케이션', '게임 수업', '게임 요소'],
    season: 'all',
    whatquizLink: '/chat?category=worksheet_gen',
    priority: 4
  },
  {
    id: 'trend-008',
    category: '교육트렌드',
    topic: 'STEAM 교육 수업 설계',
    keywords: ['STEAM', '융합교육', '통합교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-009',
    category: '교육트렌드',
    topic: '마이크로 러닝 수업에 적용하기',
    keywords: ['마이크로 러닝', '짧은 학습', '모바일 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-010',
    category: '교육트렌드',
    topic: '개별화 학습 지원 방법',
    keywords: ['개별화 학습', '맞춤 교육', '개인별 지도'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-011',
    category: '교육트렌드',
    topic: '학생 중심 수업 실천하기',
    keywords: ['학생 중심', '학습자 중심', '능동적 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-012',
    category: '교육트렌드',
    topic: '교실 공간 혁신 사례',
    keywords: ['교실 혁신', '공간 혁신', '미래 교실'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-013',
    category: '교육트렌드',
    topic: '디자인 씽킹 수업 진행하기',
    keywords: ['디자인 씽킹', '디자인 사고', '창의 수업'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-014',
    category: '교육트렌드',
    topic: '메이커 교육 학교에서 실천하기',
    keywords: ['메이커 교육', '만들기 교육', '메이커 스페이스'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-015',
    category: '교육트렌드',
    topic: '소셜 러닝 협력 학습 설계',
    keywords: ['소셜 러닝', '협력 학습', '사회적 학습'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-016',
    category: '교육트렌드',
    topic: '에듀테크 도구 선별 가이드',
    keywords: ['에듀테크', '교육 기술', 'EdTech'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-017',
    category: '교육트렌드',
    topic: '학습 분석 데이터 활용하기',
    keywords: ['학습 분석', '러닝 애널리틱스', '데이터 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-018',
    category: '교육트렌드',
    topic: '교사 PLC 운영 가이드',
    keywords: ['PLC', '전문적 학습공동체', '교사 협력'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-019',
    category: '교육트렌드',
    topic: '세계시민교육 수업 사례',
    keywords: ['세계시민교육', '글로벌 교육', '시민 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-020',
    category: '교육트렌드',
    topic: 'ESG 교육 학교에서 실천하기',
    keywords: ['ESG 교육', '지속가능발전', 'SDGs'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-021',
    category: '교육트렌드',
    topic: '디지털 시민의식 교육',
    keywords: ['디지털 시민', '디지털 윤리', '온라인 예절'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-022',
    category: '교육트렌드',
    topic: '학생 주도 프로젝트 지원하기',
    keywords: ['학생 주도', '자기주도', '프로젝트 지원'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-023',
    category: '교육트렌드',
    topic: '하이터치 하이테크 교육 균형',
    keywords: ['하이터치', '하이테크', '기술과 감성'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'trend-024',
    category: '교육트렌드',
    topic: '교육과 웰빙의 연결',
    keywords: ['교육 웰빙', '학생 행복', '전인 교육'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'trend-025',
    category: '교육트렌드',
    topic: '미래 역량 교육 방향',
    keywords: ['미래 역량', '21세기 역량', '핵심 역량'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },

  // ==========================================
  // 💪 교사 자기계발 (30개)
  // ==========================================
  {
    id: 'selfdev-001',
    category: '자기계발',
    topic: '교사 번아웃 예방과 극복',
    keywords: ['교사 번아웃', '소진 예방', '교사 건강'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'selfdev-002',
    category: '자기계발',
    topic: '교사 마음 건강 관리하기',
    keywords: ['교사 마음건강', '정신건강', '스트레스 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'selfdev-003',
    category: '자기계발',
    topic: '교직 경력에 따른 성장 전략',
    keywords: ['교사 성장', '경력 관리', '교직 발전'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-004',
    category: '자기계발',
    topic: '수업 연구회/동아리 참여하기',
    keywords: ['수업 연구회', '교사 동아리', '연구 모임'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-005',
    category: '자기계발',
    topic: '교육 관련 도서 추천 목록',
    keywords: ['교육 도서', '교사 책', '교육 서적'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-006',
    category: '자기계발',
    topic: '교사 연수 효과적으로 이수하기',
    keywords: ['교사 연수', '직무연수', '연수 선택'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-007',
    category: '자기계발',
    topic: '대학원 진학 가이드 (교사용)',
    keywords: ['교사 대학원', '석사 과정', '교육대학원'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-008',
    category: '자기계발',
    topic: '교사 부업/투자 현명하게 하기',
    keywords: ['교사 부업', '교사 투자', '추가 수입'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-009',
    category: '자기계발',
    topic: '교사 포트폴리오 관리하기',
    keywords: ['교사 포트폴리오', '업적 관리', '활동 기록'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-010',
    category: '자기계발',
    topic: '교육 콘텐츠 제작자로 성장하기',
    keywords: ['교육 콘텐츠', '교사 유튜브', '콘텐츠 제작'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-011',
    category: '자기계발',
    topic: '교사 글쓰기/출판 도전하기',
    keywords: ['교사 글쓰기', '책 출판', '교사 작가'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'selfdev-012',
    category: '자기계발',
    topic: '교사 네트워킹 효과적으로 하기',
    keywords: ['교사 네트워킹', '교사 커뮤니티', '교사 모임'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-013',
    category: '자기계발',
    topic: '수업 피드백 받고 성장하기',
    keywords: ['수업 피드백', '수업 나눔', '수업 성찰'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-014',
    category: '자기계발',
    topic: '교사 건강 관리 필수 습관',
    keywords: ['교사 건강', '직업병 예방', '건강 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-015',
    category: '자기계발',
    topic: '교사 목소리 관리하는 법',
    keywords: ['목소리 관리', '성대 건강', '발성 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-016',
    category: '자기계발',
    topic: '교사 퇴직 후 준비하기',
    keywords: ['교사 퇴직', '은퇴 준비', '제2의 인생'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'selfdev-017',
    category: '자기계발',
    topic: '교사 승진/전직 경로 이해하기',
    keywords: ['교사 승진', '전직', '교직 경로'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-018',
    category: '자기계발',
    topic: '신규 교사 1년 생존 가이드',
    keywords: ['신규 교사', '1년차 교사', '교직 입문'],
    season: 'semester-start',
    whatquizLink: '/chat',
    priority: 5
  },
  {
    id: 'selfdev-019',
    category: '자기계발',
    topic: '경력 교사의 슬럼프 극복하기',
    keywords: ['경력 교사', '슬럼프', '권태기 극복'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-020',
    category: '자기계발',
    topic: '교사 일기/저널 쓰기',
    keywords: ['교사 일기', '성찰 저널', '교직 기록'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'selfdev-021',
    category: '자기계발',
    topic: '교사 취미 생활 추천',
    keywords: ['교사 취미', '여가 활동', '취미 추천'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 2
  },
  {
    id: 'selfdev-022',
    category: '자기계발',
    topic: '교사 인간관계 지혜롭게 하기',
    keywords: ['교사 인간관계', '동료 관계', '학교 생활'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-023',
    category: '자기계발',
    topic: '교사 시간 관리 비법',
    keywords: ['시간 관리', '업무 효율', '일과 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-024',
    category: '자기계발',
    topic: '교사 방학 활용 가이드',
    keywords: ['방학 활용', '방학 계획', '휴식과 충전'],
    season: 'summer',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-025',
    category: '자기계발',
    topic: '교사 재정 관리 팁',
    keywords: ['교사 재정', '월급 관리', '교사 저축'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-026',
    category: '자기계발',
    topic: '교직 생활 행복하게 유지하기',
    keywords: ['교직 행복', '교사 만족', '보람찾기'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-027',
    category: '자기계발',
    topic: '학부모와 건강한 경계 만들기',
    keywords: ['학부모 경계', '적절한 거리', '관계 설정'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 4
  },
  {
    id: 'selfdev-028',
    category: '자기계발',
    topic: '교사 SNS 활용 가이드라인',
    keywords: ['교사 SNS', '소셜미디어', 'SNS 관리'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-029',
    category: '자기계발',
    topic: '교사로서 자기 정체성 찾기',
    keywords: ['교사 정체성', '자기 발견', '교직관'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },
  {
    id: 'selfdev-030',
    category: '자기계발',
    topic: '선배 교사에게 배우는 지혜',
    keywords: ['선배 교사', '교직 지혜', '멘토링'],
    season: 'all',
    whatquizLink: '/chat',
    priority: 3
  },

  // ==========================================
  // 🚀 SEO 확장 - PPT/학습지/이미지 (6개)
  // ==========================================
  {
    id: 'ai-ppt-001',
    category: 'AI활용',
    topic: 'AI로 수업 PPT 5분 만에 만드는 법 - 단계별 가이드',
    keywords: ['AI PPT 만들기', '수업 PPT 만들기', '교사 PPT AI'],
    season: 'all',
    whatquizLink: '/ai-ppt',
    priority: 5
  },
  {
    id: 'ai-worksheet-001',
    category: '학습지',
    topic: '2026 교사가 꼭 알아야 할 AI 학습지 만들기 도구 TOP 5',
    keywords: ['학습지 만들기', '학습지 만들기 사이트', 'AI 학습지 만들기'],
    season: 'all',
    whatquizLink: '/ai-worksheet',
    priority: 5
  },
  {
    id: 'ai-compare-001',
    category: 'AI활용',
    topic: '미리캔버스 vs 왓퀴즈 - 교사에게 더 좋은 건? 솔직 비교',
    keywords: ['미리캔버스 대안', '미리캔버스 vs 왓퀴즈', '교사 AI 도구 비교'],
    season: 'all',
    whatquizLink: '/compare/miricanvas',
    priority: 5
  },
  {
    id: 'ai-image-001',
    category: 'AI활용',
    topic: '왓퀴즈로 색칠공부 도안 만들기 - 초등 교사 활용법',
    keywords: ['색칠공부 만들기', 'AI 이미지 만들기', '교육용 이미지 생성'],
    season: 'all',
    whatquizLink: '/ai-image',
    priority: 4
  },
  {
    id: 'ai-cross-001',
    category: '수행평가',
    topic: '수행평가 학습지 AI로 만들고 자동 채점까지 - 올인원 가이드',
    keywords: ['수행평가 학습지', 'AI 수행평가 채점', '수행평가 만들기'],
    season: 'all',
    whatquizLink: '/ai-worksheet',
    priority: 5
  },
  {
    id: 'ai-productivity-001',
    category: '워라밸',
    topic: '학기말 업무 시간 200시간 줄이는 교사 AI 활용법',
    keywords: ['교사 AI 활용', '교사 업무 자동화', '교사 AI 도구'],
    season: 'semester-end',
    whatquizLink: '/guide/ai-teacher-tools',
    priority: 5
  },

  // ==========================================
  // 👥 SEO 확장 - 커뮤니티/라이브러리 (3개)
  // ==========================================
  {
    id: 'community-001',
    category: '커뮤니티',
    topic: '교사 익명 커뮤니티 어디가 좋을까? 2026 교사 소통 플랫폼 비교',
    keywords: ['교사 커뮤니티', '교사 익명 게시판', '교원 커뮤니티 사이트'],
    season: 'all',
    whatquizLink: '/community/about',
    priority: 4
  },
  {
    id: 'library-001',
    category: 'AI활용',
    topic: '교사 수업자료 공유 사이트 TOP 5 - 인디스쿨부터 AI 라이브러리까지',
    keywords: ['수업자료 공유', '교사 자료실', '수업자료 사이트'],
    season: 'all',
    whatquizLink: '/library',
    priority: 5
  },
  {
    id: 'library-002',
    category: '학습지',
    topic: 'AI로 만든 수업자료 공유하기 - 라이브러리 자동 저장 & 나눔터 공유',
    keywords: ['학습지 공유', '수업 PPT 공유', '교사 자료 나눔'],
    season: 'all',
    whatquizLink: '/library',
    priority: 4
  }
];

// 카테고리별 통계
export const getTopicsByCategory = () => {
  const categories = {};
  contentTopics.forEach(topic => {
    if (!categories[topic.category]) {
      categories[topic.category] = [];
    }
    categories[topic.category].push(topic);
  });
  return categories;
};

// 시즌별 토픽 필터링
export const getTopicsBySeason = (season) => {
  return contentTopics.filter(topic => 
    topic.season === season || topic.season === 'all'
  );
};

// 우선순위별 정렬
export const getTopicsByPriority = (minPriority = 1) => {
  return contentTopics
    .filter(topic => topic.priority >= minPriority)
    .sort((a, b) => b.priority - a.priority);
};

// 오늘의 토픽 선정 (랜덤 + 시즌 고려)
export const getTodaysTopic = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  
  // 시즌 결정
  let season = 'all';
  if (month === 3 || month === 9) season = 'semester-start';
  else if (month === 7 || month === 12 || month === 1 || month === 2) season = 'semester-end';
  else if (month === 8) season = 'summer';
  else if (month === 1 || month === 2) season = 'winter';
  
  // 해당 시즌 + 우선순위 높은 토픽 중 랜덤 선택
  const eligibleTopics = contentTopics.filter(topic => 
    (topic.season === season || topic.season === 'all') && 
    topic.priority >= 3
  );
  
  // 날짜 기반 시드로 일관된 랜덤 선택
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  const index = dayOfYear % eligibleTopics.length;
  
  return eligibleTopics[index];
};

// 총 토픽 수
export const getTotalTopicsCount = () => contentTopics.length;

export default contentTopics;
